var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: _vm.height, width: _vm.width, position: 'relative' })},[_c('bar-chart',{staticStyle:{"height":"100%","width":"100%"},attrs:{"chart-data":_vm.datacollection,"options":_vm.chartOptions,"height":null,"width":null}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }